import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import NavigationBar from '../../../common/navigation-bar';
import newslettersService from '../../../../services/newsletters';

class NewslettersNavigationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    newslettersService.getNewsletters(this.props.tag)
      .then(this._onNewslettersChange)
      .catch(error => {

      });    
  }

  componentDidUpdate(props) {
    if (props.url === this.props.url) return;

    this.setState((prevState) => {
      return this._generateActionsData(props.newsletterId, prevState.newslettersCount);
    });  
  }

  _generateActionsData(newsletterId, count) {
    const prefixForNewsletter = `/newsletters${this.props.tag ? `/ag/${this.props.tag}` : '' }`;
    const prefixForTypeCatalog = `/newsletters/ag/${ this.props.tag || 'angular' }`;

    return {
      previous: {
        link: `${prefixForNewsletter}/${Number(newsletterId) - 1}`,
        tooltip: 'previous newsletter',
        isDisabled: newsletterId <= 1  
      },
      next: {
        link: `${prefixForNewsletter}/${Number(newsletterId) + 1}`,
        tooltip: 'next newsletter',
        isDisabled: this._isNextDisabled(newsletterId, count)  
      },
      all: {
        link: prefixForTypeCatalog,
        tooltip: 'Back to the list',
        isDisabled: false
      },
    };
  }

  _isNextDisabled(newsletterId, count) {
    return count === undefined || newsletterId >= count;
  }

  _onNewslettersChange = (newsletters) => {
    this.setState(this._generateActionsData(this.props.newsletterId, newsletters.length));
  }

  render() {
    return (
      <div className='newsletters-navigation-bar'>
        { this.state.previous && <NavigationBar {...this.state} /> }
      </div>
    );
  }  
}

NewslettersNavigationBar.propTypes = {
  newsletterId: PropTypes.number.isRequired,
  tag: PropTypes.string,
}

export default NewslettersNavigationBar;